import getLang from 'I18n/utils/getLang';
import { useAppInstallability } from 'marketplace-ui-apps-core/installability/hooks/useAppInstallability';
import { getDataFetchingClientRequestState } from 'marketplace-ui-common/dataFetchingClient/utils/getDataFetchingClientRequestState';
import LoadingWrapper from 'marketplace-ui-common/layout/components/LoadingWrapper';
import { useState } from 'react';
import { FeatureCompatibilityModal } from './compatibility/FeatureCompatibilityModal';
import { DetailsPageContext } from './context/DetailsPageContext';
import { useUnifiedDetails } from './hooks/useUnifiedDetails';
import { DetailsPage } from './layout/DetailsPage';
import { ProductBuyBox } from './layout/cards/ProductBuyBox';
import { ProductFeaturesCard } from './layout/cards/ProductFeaturesCard';
import { ProductFunctionalityCard } from './layout/cards/ProductFunctionalityCard';
import { ProductInfoCard } from './layout/cards/ProductInfoCard';
import { ProductOverviewCard } from './layout/cards/ProductOverviewCard';
import { ProductPricingCard } from './layout/cards/ProductPricingCard';
import { ProductRequirementsCard } from './layout/cards/ProductRequirementsCard';
import { ProductReviewsCard } from './layout/cards/ProductReviewsCard';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function Details({
  appContext,
  productType,
  published,
  slug,
  userInfo
}) {
  const [compatibilityModalOpen, setCompatibilityModalOpen] = useState(false);
  const {
    unifiedDetailsData,
    unifiedDetailsLoading,
    unifiedDetailsError
  } = useUnifiedDetails({
    slug,
    language: getLang()
  });
  const unifiedDetailsRequestStatus = getDataFetchingClientRequestState(unifiedDetailsError, unifiedDetailsLoading);
  const {
    agencyPricingUrl,
    benefits,
    casesUrl,
    categoryV2,
    chatUrl,
    companyName,
    companyUrl,
    currency,
    dataSyncHowItWorks,
    dataSyncInfo,
    dataSyncs,
    email,
    facebookUrl,
    features,
    formUrl,
    iconUrl,
    integrationFeatures,
    languages,
    meetingUrl,
    name,
    neededScopeGroups,
    offering,
    offeringId,
    phone,
    pricings,
    pricingUrl,
    privacy2Url,
    privacy3Url,
    privacyUrl,
    screenshots,
    setupUrl,
    supportLanguages,
    supportUrl,
    tagline,
    termsUrl,
    tiers,
    videoUrl
  } = unifiedDetailsData;
  const {
    connectionType,
    homemade,
    installsCount
  } = offering || {};

  // This info will be returned from the Unified Details Service V2
  // But for now, we're using the separate apps-specific endpoint/hook
  // To get real data for the page
  const {
    installability,
    installabilityLoading,
    installabilityError,
    missingCompatibilityRequirements
  } = useAppInstallability({
    offeringId,
    appContext,
    published,
    features
  });
  const installabilityRequestStatus = getDataFetchingClientRequestState(installabilityError, installabilityLoading);
  return /*#__PURE__*/_jsx(LoadingWrapper, {
    requestStatus: [unifiedDetailsRequestStatus, installabilityRequestStatus],
    children: /*#__PURE__*/_jsxs(DetailsPageContext.Provider, {
      value: {
        appContext,
        iconUrl,
        name,
        productType,
        published,
        userInfo
      },
      children: [/*#__PURE__*/_jsx(DetailsPage, {
        leftColumn: /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(ProductBuyBox, {
            companyName: companyName,
            companyUrl: companyUrl,
            formUrl: formUrl,
            installsCount: installsCount,
            meetingUrl: meetingUrl,
            reviewSummary: {
              overallRating: 4.5,
              reviewCount: 100
            },
            tagline: tagline
          }), /*#__PURE__*/_jsx(ProductRequirementsCard, {
            connectionType: connectionType,
            features: features,
            homemade: homemade,
            installability: installability,
            missingCompatibilityRequirements: missingCompatibilityRequirements,
            neededScopeGroups: neededScopeGroups,
            onCompatibilityModalOpen: () => setCompatibilityModalOpen(true),
            pricings: pricings,
            tiers: tiers
          })]
        }),
        rightColumn: /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(ProductOverviewCard, {
            casesUrl: casesUrl,
            benefits: benefits,
            screenshots: screenshots,
            setupUrl: setupUrl,
            videoUrl: videoUrl
          }), /*#__PURE__*/_jsx(ProductFeaturesCard, {
            features: features,
            integrationFeatures: integrationFeatures,
            missingCompatibilityRequirements: missingCompatibilityRequirements,
            onCompatibilityModalOpen: () => setCompatibilityModalOpen(true)
          }), /*#__PURE__*/_jsx(ProductFunctionalityCard, {
            dataSyncHowItWorks: dataSyncHowItWorks,
            dataSyncInfo: dataSyncInfo,
            dataSyncs: dataSyncs
          }), /*#__PURE__*/_jsx(ProductReviewsCard, {
            productId: offeringId
          }), /*#__PURE__*/_jsx(ProductPricingCard, {
            agencyPricingUrl: agencyPricingUrl,
            currency: currency,
            pricingUrl: pricingUrl,
            pricings: pricings
          }), /*#__PURE__*/_jsx(ProductInfoCard, {
            details: {
              companyName,
              companyUrl,
              categoryV2,
              languages,
              installsCount
            },
            support: {
              chatUrl,
              email,
              facebookUrl,
              homemade,
              phone,
              supportLanguages,
              supportUrl
            },
            legal: {
              homemade,
              privacyUrl,
              privacy2Url,
              privacy3Url,
              termsUrl
            }
          })]
        })
      }), compatibilityModalOpen && /*#__PURE__*/_jsx(FeatureCompatibilityModal, {
        features: features,
        installability: installability,
        onClose: () => setCompatibilityModalOpen(false),
        trackInteraction: () => {}
      })]
    })
  });
}